import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DropdownComponent } from 'src/app/components/shared/dropdown/dropdown.component';
import { AddResumeCertification } from 'src/app/models/resume/add-resume';
import { DropDownKeywords, DropdownOption } from 'src/app/models/shared/dropdown-option';
import { DropdownService } from 'src/app/services/dropdown.service';
import { ResumeService } from 'src/app/services/resume.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-certification',
  imports: [CommonModule, ReactiveFormsModule, DropdownComponent],
  templateUrl: './modal-certification.component.html',
  styleUrl: './modal-certification.component.css'
})
export class ModalCertificationComponent {
  public resumeId = input<number | null>(null);
  public onResumeCertification = output<AddResumeCertification>();

  private readonly resumeService = inject(ResumeService);
  private readonly dropdownService = inject(DropdownService);

  public form = new FormGroup({
    id: new FormControl(0),
    resumeId: new FormControl(0),
    institution: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
    certificationId: new FormControl(null, [Validators.required]),
    name: new FormControl('', [Validators.maxLength(1000)]),
    completionDate: new FormControl(null, [Validators.required]),
    expirationDate: new FormControl(null),
    description: new FormControl('', [Validators.maxLength(1000)]),
    isEnabled: new FormControl(true)
  });

  isLoading = signal<boolean>(false);

  certifications: DropdownOption[] = [];

  ngOnInit(): void {
    this.getOptions();
  }

  getOptions() {
    this.dropdownService.GetOptions(DropDownKeywords.Certifications).subscribe({
      next: res => {
        this.certifications = res;
      }
    });
  }

  reset() {
    this.form.reset();
    this.form.patchValue({
      isEnabled: true
    });
  }

  closeModal() {
    this.reset();
    let divModal = document.getElementById('modalCertificacion');
    let modal = (window as any).bootstrap.Modal.getInstance(divModal);
    modal.hide();
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const resumeCertification = {
      ...this.form.getRawValue(),
      resumeId: this.resumeId(),
      name: this.certifications.find(x => x.id == this.form.getRawValue().certificationId)?.text,
      expirationDate: this.form.getRawValue().expirationDate || null
    } as any as AddResumeCertification;

    if (this.resumeId()) {
      this.isLoading.set(true);
      this.resumeService.addResumeCertification({
        ...resumeCertification
      }).subscribe({
        next: res => {
          this.isLoading.set(false);
          this.onResumeCertification.emit(resumeCertification)
          this.closeModal();
        }, error: res => {
          this.isLoading.set(false);
          Swal.fire({
            title: 'Error',
            text: 'Ocurrió un error al guardar el registro.',
            icon: 'error',
            confirmButtonColor: '#d33'
          });
        }
      })
    } else {
      this.onResumeCertification.emit(resumeCertification);
      this.closeModal();
    }
  }
}
